module.exports = __webpack_public_path__ + "img/administrative_image.eeea3d18.jpg";